import Vue from 'vue'
import utils from '../../utils'

// 设置私有变量
const type = Symbol('type')

class MessageConstroller {
  constructor () {
    this.timer = null
    this.list = []
    this.event = new Vue()
    this[type] = {
      info: 'gkui-message-info',
      success: 'gkui-message-success',
      warning: 'gkui-message-warning',
      error: 'gkui-message-error',
      loading: 'gkui-message-loading',
      toast: 'gkui-message-toast'
    }
  }
  /**
   * 把 组件实例 注册到 constroller 中
   * @param {VueComponent} view message组件视图
   */
  register (view) {
    this.event.$messageInstance = view
  }

  /**
   * 设置自定义类型的message，其实就是自定义class
   * @param {Map} options     类型 map
   * @param {Boolean} merge   合并或者替换默认类型
   */
  setType (options, merge) {
    this[type] = Object.assign(merge ? this[type] : {}, options)
  }

  /**
   * 获取类型 样式名
   * @param {String} typeName 类型名
   */
  getType (typeName) {
    return this[type][typeName]
  }

  push (data) {
    clearTimeout(this.timer)
    let name = data.name || utils.guid()

    let _message = Object.assign({
      name: name
    }, data)
    // 把 config 中的top 属性 添加给 MessageBox
    let messageBoxProps = {
      styles: {top: _message.top},
      transitionName: _message.transitionName || 'fade-up'
    }
    if (data.single) {
      if (this.list.length) {
        return
      }
    }
    this.list.push(_message)
    this.event.$messageInstance.add(_message, messageBoxProps)
    return {
      eventBus: this.event,
      name: _message.name
    }
  }

  remove (name) {
    this.list = this.list.filter(item => item.name !== name)
  }

  clear () {
    this.list = []
  }

  destory () {
    this.timer = setTimeout(() => {
      this.clear()
    }, 30)
  }
}
export default new MessageConstroller()
